import { useLanguage } from "@/lib/i18n";
import { getArticle } from "@/lib/blogContent";
import { ArticleCard } from "./ArticleCard";

interface RelatedArticlesProps {
  slugs: string[];
}

export function RelatedArticles({ slugs }: RelatedArticlesProps) {
  const { t } = useLanguage();
  const articles = slugs.map(getArticle).filter(Boolean) as NonNullable<ReturnType<typeof getArticle>>[];

  if (articles.length === 0) return null;

  return (
    <section className="mt-16">
      <h2 className="text-2xl font-serif font-semibold text-foreground mb-6">
        {t('blog.relatedArticles')}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {articles.map(article => (
          <ArticleCard key={article.slug} article={article} />
        ))}
      </div>
    </section>
  );
}
